import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, money } from "@/lib/api";

export const DepositOffer = ({ deposit, onSkip, prefix = "pricing", skipLabel = "Skip, contact me first" }) => {
  const [paying, setPaying] = useState(false);
  const pay = async () => {
    setPaying(true);
    try {
      const base = `${window.location.origin}/deposit/${deposit.token}`;
      const r = await api.post(`/public/deposits/${deposit.token}/paypal/order`, { return_url: base, cancel_url: `${base}?cancelled=1` });
      window.location.href = r.data.approve_url;
    } catch (err) { toast.error(errMsg(err, "Could not start PayPal checkout")); setPaying(false); }
  };
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-950/50 p-5 text-left" data-testid={`${prefix}-deposit-offer`}>
      <p className="font-semibold mb-1">Want to book your spot now?</p>
      <p className="text-sm text-slate-400 mb-4">Pay a {deposit.percent}% deposit of <span className="num text-slate-100 font-semibold">{money(deposit.amount, deposit.currency)}</span>. It's credited in full on your final invoice.</p>
      <Button data-testid={`${prefix}-pay-deposit`} disabled={paying} onClick={pay} className="w-full h-11 rounded-full bg-[#ffc439] hover:bg-[#f2b92f] text-[#003087] font-bold">{paying ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Pay deposit with <span className="italic ml-1">PayPal</span></>}</Button>
      <Button data-testid={`${prefix}-skip-deposit`} variant="ghost" onClick={onSkip} className="w-full mt-2 text-slate-400">{skipLabel}</Button>
    </div>
  );
};
